<script lang="ts" setup>
import RouterLinkButton from '@/components/common/RouterLinkButton.vue'
import ValueWithLabel from '@/components/common/ValueWithLabel.vue'
import { useBowlerStore } from '@/store/bowler-app/bowler'
import { formatFloat, formatValue } from '@/utils/format'

const bowler = useBowlerStore()
</script>

<template>
  <div class="bowler-results-summary">
    <div class="bowler-results-summary-data">
      <ValueWithLabel
        :label="$t('bowler-scores.current-average')"
        :value="formatFloat(bowler.currentAverage, 2)"
      />
      <ValueWithLabel
        :label="$t('bowler-scores.previous-average')"
        :value="formatFloat(bowler.previousAverage, 2)"
      />
      <ValueWithLabel
        :label="$t('bowler-scores.cut-score-games')"
        :value="formatFloat(bowler.cutScoreGames, 0)"
      />
      <ValueWithLabel
        :label="$t('bowler-scores.season-games')"
        :value="formatFloat(bowler.seasonGames, 0)"
      />
      <ValueWithLabel
        :label="$t('bowler-scores.class')"
        :value="formatValue(bowler.currentClass)"
      />
    </div>

    <RouterLinkButton :to="{ path: '/results' }">
      {{ $t('nav.results') }}
    </RouterLinkButton>
  </div>
</template>

<style lang="scss" scoped>
.bowler-results-summary {
  display: flex;
  flex-flow: column nowrap;
  gap: 1em;

  .bowler-results-summary-data {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75em;
    margin: 0 0.5em;
  }
}
</style>
